<template>
  <div class="video">
    <video
      :src="value.videoSrc"
      :autoplay="value.autoPlay"
      muted
      loop
      playsinline
      preload="auto"
    />
  </div>
</template>

<script setup>
defineProps({
  value: {
    type: Object,
    required: true,
  },
});
</script>

<style lang="scss" scoped>
  .video {
    position: relative;
    display: flex;
    width: 100%;
    margin: 2.4rem 0;
    overflow: hidden;
    border-radius: .8rem;

    video {
      width: 100%;
      height: auto;
      aspect-ratio: auto 16 / 9;
    }

    // A pseudo-element instead of an outline, so the hairline stays above
    // the video even when the browser composites it into its own layer.
    &::after {
      position: absolute;
      inset: 0;
      pointer-events: none;
      content: "";
      border-radius: inherit;
      box-shadow: inset 0 0 0 1px $border-color;
    }
  }
</style>
